import Creators from './actions'

export const clearSong = Creators.clearSong
export const decrementOffset = Creators.decrementOffset
export const getState = Creators.getState
export const incrementOffset = Creators.incrementOffset
export const incrementTimer = Creators.incrementTimer
export const playerStop = Creators.playerStop
export const resetTimer = Creators.resetTimer
export const setOffset = Creators.setOffset
export const startTimer = Creators.startTimer
export const stopTimer = Creators.stopTimer
export const toggleMinimizedApp = Creators.toggleMinimizedApp
export const toggleOffsetView = Creators.toggleOffsetView
export const updateSong = Creators.updateSong
export const updateStatus = Creators.updateStatus



// WEBPACK FOOTER //
// ./src/duck/operations.js